import React from "react";

const Footer: React.FC = () => (
  <footer>
        <p>© 2025 Mi Aplicación</p> {" "}
  </footer>
);

export default Footer;
